import { DatePipe, NgClass, NgStyle, NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { AnimacionVideoComponent } from "../../animacion-video/animacion-video.component";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-fila-dos-columnas",
  templateUrl: "./fila-dos-columnas.component.html",
  styleUrls: ["./fila-dos-columnas.component.css"],
  imports: [NgClass, NgStyle, NgFor, NgIf, RouterLink, AnimacionVideoComponent, DatePipe, KebabCasePipe, SafeResourceUrlPipe, SkeletonImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilaDosColumnasComponent {
  @Input() noticias = [];
  @Input() descripcion: true;
  @Input() imagen: true;
  @Input() idStart: any;
  @Input() lcp: boolean;
  @Input() autorEmpresa;
  @Input() showFecha = true;

  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  trackByNoticia(index: number, noticia: any): string {
    return noticia?.idVideo;
  }
}
